import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { warn } from '../util/console';
var model = {
  agentIdentifier: '',
  ee: undefined
};
export var SharedContext = /*#__PURE__*/_createClass(function SharedContext(context) {
  var _this = this;

  _classCallCheck(this, SharedContext);

  try {
    if (_typeof(context) !== 'object') return warn(8);
    this.sharedContext = {};
    Object.assign(this.sharedContext, model);
    Object.entries(context).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (Object.keys(model).includes(key)) _this.sharedContext[key] = value;
    });
  } catch (err) {
    warn(9, err);
  }
});